module.exports = __webpack_public_path__ + "img/kk-2.874af982.png";